import script from "./BottomNavbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./BottomNavbar.vue?vue&type=script&lang=ts&setup=true"

import "./BottomNavbar.vue?vue&type=style&index=0&id=1755553e&lang=css"

const __exports__ = script;

export default __exports__